import React, { Component } from 'react';
import config from 'react-global-configuration';
import getLocale from '../../../i18n/getLocale';
import RequestApi from '../../Miscelania/RequestApi';
import ScheduleInitialsSelectModal from './ScheduleInitialsSelectModal';

class ScheduleGradeEquipmentChiefAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      modal_props: false,
      loaded: 0,
      staff_id: this.props.staff_id,
      date_start: this.props.date_start,
      date_finish: this.props.date_finish,
      schedule_grade_id: this.props.schedule_grade_id,
    };

    this.showModal = this.showModal.bind(this);
    this.modalPropsOff = this.modalPropsOff.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0) || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        types_list: newProps.types_list,
        staff_id: newProps.staff_id,
        schedule_grade_id: newProps.schedule_grade_id,
        loaded: 1,
      });
    }
  }

  showModal () {
    this.setState({ modal_props: true});
  }

  modalPropsOff () {
    this.setState({ modal_props: false});
  }


  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} handleLoaded={this.props.handleLoaded} />
  <div className="row">
    <ScheduleInitialsSelectModal handleAlert={this.props.handleAlert} modalPropsOff={this.modalPropsOff} updateData={this.props.updateData} modal_props={this.state.modal_props} staff_id={this.state.staff_id} schedule_grade_id={this.state.schedule_grade_id} date_start={this.state.date_start} date_finish={this.state.date_finish} types_list={this.state.types_list} type={'EQUIP'} />
    <div className="col-md-5">
      <input type="text" name="date_start" className="form-control" placeholder={this.locale.GradesDeEscala.EditarGradeDeEscala.tabChefesDeEquipamento.placeholder.DataInicial} value={this.state.date_start} onChange={this.handleChange.bind(this, 'date_start')} />
    </div>
    <div className="col-md-5">
      <input type="text" name="date_finish" className="form-control" placeholder={this.locale.GradesDeEscala.EditarGradeDeEscala.tabChefesDeEquipamento.placeholder.DataFinal} value={this.state.date_finish} onChange={this.handleChange.bind(this, 'date_finish')} />
    </div>
    <div className="col-md-2">
      <button onClick={() => {this.showModal()}} className="btn btn-primary btn-block"><i className="fa fa-fw fa-check"></i></button>
    </div>
  </div>
</div>
    );
  }
}


export default ScheduleGradeEquipmentChiefAdd;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeEquipmentChiefAdd.js